<!-- hidden label to calculate if there is a label or not -->
<app-label-inflator #labelCalculator hidden [labelComponentInterface]="card"></app-label-inflator>

<div class="embedded-image-card-container" #productCard>
  <!-- card content -->
  <div
    class="marketing-card-container embed-image-card"
    fxLayout="column"
    fxLayoutAlign="space-between"
    fxLayoutGap="0.5rem"
    [style.background-color]="(card | method: 'getCardColor') || '#F1F2F3'">
    <div class="top-row" fxLayout="row" fxFlex="16">
      <app-card-number
        #num
        [style.width]="num.width | async"
        [card]="card"
        [changeBackgroundColor]="false"
        [index]="index">
      </app-card-number>
      <app-asset
        *ngFor="let badge of card | method: 'getBadges'"
        class="embedded-card-badge-asset"
        [style.width]="num.width | async"
        [asset]="badge.image"></app-asset>
      <app-card-price
        class="card-price"
        [ngClass]="{
          'black-shadow': !(this | method: 'isDarkTextColor'),
          'white-shadow': (this | method: 'isDarkTextColor')
        }"
        fxFlex
        [card]="card"></app-card-price>
    </div>
    <div
      class="name-desc"
      fxFlex
      fxLayout="column"
      fxLayoutAlign="start stretch"
      [ngStyle]="{
        color: card | method: 'getCardTextColor'
      }">
      <div
        class="marketing-card-product-name"
        appFitText
        [percentageOfParent]="this | method: 'getProductNameTextPercentage'"
        [parentContainer]="productCard">
        {{ card | method: 'getProductName' }}
      </div>
      <div fxFlex>
        <div
          *ngIf="card | method: 'getProductDesc'"
          class="marketing-card-product-desc"
          [ngStyle]="{
            '-webkit-line-clamp': cardCount < 9 ? '4' : '3'
          }"
          appFitText
          [percentageOfParent]="this | method: 'getProductDescTextPercentage'"
          [parentContainer]="productCard">
          {{ card | method: 'getProductDesc' }}
        </div>
      </div>
    </div>
    <div class="product-info" fxFlex="40" fxLayout="row" fxLayoutGap="0.5rem">
      <div fxFlex="50" class="position-relative">
        <app-asset
          *ngIf="viewModel.hasAsset$ | async; else fallbackIcon"
          class="embedded-card-image-asset"
          [asset]="card | method: 'getAsset'"></app-asset>
        <ng-template #fallbackIcon>
          <img class="embedded-card-image-asset" [src]="viewModel.assetFallBackIconUrl$ | async" alt="" />
        </ng-template>
        <div class="label-container" fxLayout="row" fxLayoutAlign="center end">
          <app-label-inflator
            *ngIf="labelCalculator.currentLabelText$ | async | exists"
            [labelComponentInterface]="card"
            [fitTextParentContainer]="productCard"
            [fitTextPercentageOfParent]="this | method: 'getLabelPercentage'"
            [fitTextDisabled]="false">
          </app-label-inflator>
        </div>
      </div>
      <div
        fxFlex="50"
        fxLayout="column"
        fxLayoutAlign="space-evenly stretch"
        #infoContainer
        [ngStyle]="{
          color: card | method: 'getCardTextColor'
        }">
        <div [fxFlex]="20">
          <div
            class="marketing-card-product-brand"
            appFitText
            [percentageOfParent]="this | method: 'getProductInfoTextPercentage'"
            [parentContainer]="productCard">
            {{ card | method: 'getProductBrand' }}
          </div>
        </div>
        <div
          [fxFlex]="20"
          *ngIf="
            (card | method: 'getProductType') !== Types.ProductType.Edible &&
            (card | method: 'getProductType') !== Types.ProductType.Beverage
          ">
          <div
            *ngIf="card | method: 'getIsThcAndCbdProduct'"
            class="marketing-card-product-size"
            appFitText
            [percentageOfParent]="this | method: 'getProductInfoTextPercentage'"
            [parentContainer]="productCard">
            {{ card | method: 'getSizeString' }}
          </div>
        </div>
        <div [fxFlex]="20">
          <div
            *ngIf="card | method: 'getIsThcAndCbdProduct'"
            class="marketing-card-product-thc"
            appFitText
            [percentageOfParent]="this | method: 'getProductCannabinoidTextPercentage'"
            [parentContainer]="productCard">
            {{ card | method: 'getThcString' }}
          </div>
        </div>
        <div [fxFlex]="20">
          <div
            *ngIf="card | method: 'getIsThcAndCbdProduct'"
            class="marketing-card-product-cbd"
            appFitText
            [percentageOfParent]="this | method: 'getProductCannabinoidTextPercentage'"
            [parentContainer]="productCard">
            {{ card | method: 'getCbdString' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
